import React from 'react';
import { useI18n } from 'app/components/localization';
import { useCss } from 'app/utils/css';
import SettingsSection from './SettingsSection';
import { CheckboxField } from 'app/components/presentation/forms/Fields';
import SendOnEnterConsumer from 'app/components/chat/SendOnEnterConsumer';

const ChatSettings: React.FunctionComponent = () => {
  const css = useCss();
  const { t } = useI18n();

  return (
    <SettingsSection title={t('rtc.settings.chat.title')}>
      <div className={css('chatSettingsContainer', { margin: '1em 0', textAlign: 'left' })}>
        <SendOnEnterConsumer>{({ value, setValue }) =>
          <CheckboxField
            label={t('rtc.settings.chat.send-on-enter-label')}
            description={t('rtc.settings.chat.send-on-enter-description')}
            onToggle={setValue}
            checked={value}
          />
        }</SendOnEnterConsumer>
      </div>
    </SettingsSection>
  );
};

export default ChatSettings;
